import Modal from "~/common/components/Modal";
import { Button, Stack, styled } from "~/common/mui";

import { useIsMinTabletSize } from "~/common/hooks/useMediaQuery";
import { IMG_STOPWATCH_GRAY } from "~/utils/url/staticResources";
import { useTranslation } from "react-i18next";

const Content = styled(Stack)(({ theme }) => ({
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  textAlign: "center",
  flex: 1,
  [theme.breakpoints.up("tablet")]: {
    textAlign: "left",
    justifyContent: "flex-start",
    alignItems: "flex-start",
  },
}));

interface Props {
  onLogin: () => void;
}

export const SessionExpiredPopup = ({ onLogin }: Props) => {
  const isMinTablet = useIsMinTabletSize();

  const { t } = useTranslation();

  return (
    <Modal
      onClose={onLogin}
      title={t("popup.autologout.title")}
      footerChildren={
        <Button fullWidth={!isMinTablet} onClick={onLogin}>
          {t("popup.autologout.btn.login")}
        </Button>
      }
    >
      <Content>
        <div>{t("popup.autologout.content.expired")}</div>
        {!isMinTablet && <img style={{ width: 120 }} src={IMG_STOPWATCH_GRAY} />}
      </Content>
    </Modal>
  );
};
